export default "__VITE_ASSET__$xkl92KB__"